// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"3bdc57bf","203":"ad2f26a9","228":"ed4156be","235":"40b3ba45","429":"69c5c8a9","704":"8e47425b","744":"925dc4f8","927":"3326161b","955":"7ce7e5ed","985":"b1431286"}[chunkId] + ".chunk.js";
};